const brInvoices = {
  hausefulInvoices: {
    total: 'Total',
    selectAll: 'Selecionar todas',
    selectedCount: '{count} nota(s) selecionada(s)',
    host: 'Host',
    customer: 'Cliente',
    invoices: 'Faturas',
    subsidiary: 'Filial',
    fortnight: 'Quinzenas',
    realEstate: 'Cliente',
    exportToExcel: 'Gerar Excel',
    firstHalf: 'Primeira quinzena',
    secondHalf: 'Segunda quinzena',
    noInvoices: 'Nenhum registro encontrado',
    pending: 'Pendentes',
    sent: 'Enviadas',
    paid: 'Pagas',
    selectedInvoiceValues: 'Total',
    waitingApproval: 'Aguardando aprovação',
    waitingTransfer: 'Aguardando transferência',
    refused: 'Recusadas',
    approved: 'Aprovadas',
    transfers: 'Transferências',
    paymentList: 'Lista de pagamentos',
    received: 'Recebidas',
    withDateLimit: 'Entre {date}',
    withoutDateLimit: 'Sem filtro de datas',
    withoutPaymentLink: 'Sem vínculo',
    emittedOutsideThePlatform: 'Asaas',
    actions: {
      download: 'Baixar',
      edit: 'Editar',
      show: 'Visualizar nota fiscal',
      showTransfer: 'Visualizar transferência',
      exclude: 'Excluir',
      sendInvoice: 'Enviar nota fiscal',
      resendInvoice: 'Reenviar nota fiscal',
      approve: 'Aprovar',
      refuse: 'Recusar',
      cancel: 'Cancelar',
      viewInvoice: 'Ver nota fiscal',
      approveSelected: 'Aprovar selecionados',
      comment: 'Comentário',
      payInvoices: 'Pagar faturas',
      openInvoicePdf: 'Abrir PDF da nota',
      linkPayments: 'Vincular pagamentos',
      retryTransfer: 'Tentar transferir novamente',
    },
    headers: {
      appointmentCode: 'Cód. Agendamento',
      createdAt: 'Criado em',
      movementValue: 'Custo Imobiliária',
      hostValue: 'Valor Host',
      hausefulValue: 'Valor Hauseful',
      realtyQuantity: 'Qtd. Imóveis',
      transactionId: 'Transação',
      status: 'Status',
      total: 'Total',
      value: 'Valor',
      customer: 'Cliente',
      service: 'Serviço',
      date: 'Data',
      description: 'Descrição',
      branch: 'Filial',
      actions: 'Ações',
      code: 'Código',
      createdBy: 'Criado por',
      realEstate: 'Imobiliária',
      emission: 'Emissão',
      paymentLink: 'Vínculo',
      invoiceFile: 'Nota',
      creation: 'Criação',
      realties: 'Imóveis',
      host: 'Host',
      paymentType: 'Tipo de pagamento',
      receiver: 'Destinatário',
      sender: 'Emissor',
      comment: 'Comentário',
      transferStatus: 'Status da transferência',
      awaitingTransfer: 'Aguardando transferência',
      document: 'Documento',
      totalValue: 'Valor total',
      file: 'Arquivo',
      refuseReason: 'Motivo da recusa',
      transfer: 'Transferência',
      analysis: 'Análise',
      startDate: 'Início',
      endDate: 'Término',
    },
    modals: {
      exclude: {
        title: 'Excluir fatura',
        warning: 'Esta é uma ação sem volta',
        action: 'Excluir',
      },
      show: {
        title: 'Visualizar fatura',
        createdAt: 'Criado em',
        file: 'Arquivo',
        download: 'Baixar',
        createdBy: 'Criado por',
        client: 'Cliente',
        branch: 'Filial',
        paymentList: 'Lista de pagamentos',
      },
      upload: {
        title: 'Enviar fatura',
        titleUpdate: 'Reenviar fatura',
        createdAt: 'Criado em',
        file: 'Arquivo',
        download: 'Baixar',
        createdBy: 'Criado por',
        client: 'Cliente',
        branch: 'Filial',
        addFileToUpdate: 'Adicionar arquivo para atualizar',
        success: 'Nota fiscal enviada com sucesso.',
      },
      approve: {
        title: 'Aprovar fatura',
        message: 'Você está prestes a aprovar a fatura. Deseja continuar?',
        success: 'A fatura foi aprovada com sucesso.',
      },
      refuse: {
        title: 'Recusar fatura',
        message: 'Você está prestes a recusar a fatura. Deseja continuar?',
        success: 'A fatura foi cancelada com sucesso.',
      },
      remove: {
        title: 'Excluir fatura',
        message: 'Você está prestes a excluir a fatura. Deseja continuar?',
        success: 'A fatura foi removida com sucesso.',
      },
      pay: {
        title: 'Pagar fatura',
        message: 'Você está prestes a pagar as seguintes faturas.',
        success: 'As faturas foram pagas com sucesso.',
      },
      generateAsaas: {
        title: 'Emitir nota fiscal',
        action: 'Emitir nota fiscal',
        message: 'Você está prestes a emitir a nota fiscal via Asaas para os pagamentos abaixo. A emissão é processada pela prefeitura e pode levar alguns minutos. Deseja continuar?',
        success: 'A emissão da nota fiscal foi iniciada com sucesso. O PDF ficará disponível assim que a prefeitura autorizar.',
        error: 'Não foi possível emitir a nota fiscal. Tente novamente.',
      },
      generateAsaasBatch: {
        title: 'Emitir notas selecionadas',
        action: 'Emitir selecionadas',
        selected: 'Seleção',
        message: 'Você está prestes a emitir as notas fiscais selecionadas via Asaas. Cada uma é um documento fiscal e a emissão é processada pela prefeitura, o que pode levar alguns minutos. Deseja continuar?',
        success: '{count} nota(s) enviada(s) para emissão. Os PDFs ficarão disponíveis assim que a prefeitura autorizar.',
        partial: '{count} nota(s) não puderam ser emitidas. As demais foram enviadas e já saíram de Pendentes.',
        error: 'Não foi possível emitir as notas selecionadas. Tente novamente.',
      },
      linkPayments: {
        title: 'Vincular pagamentos',
        action: 'Vincular',
        message: 'Esta nota foi emitida direto no Asaas e ainda não sabemos quais vistorias ela cobriu. Escolha a quinzena correspondente para que os pagamentos saiam de Pendentes.',
        invoiceValue: 'Valor da nota',
        matches: 'Valor confere',
        payments: 'pagamento(s)',
        empty: 'Nenhum pagamento pendente deste cliente.',
        success: 'Pagamentos vinculados à nota fiscal.',
        error: 'Não foi possível vincular os pagamentos. Tente novamente.',
      },
      defaultActions: {
        close: 'Fechar',
        cancel: 'Cancelar',
      },
    },
    filters: {
      title: 'Filtros',
      emissionDate: 'Data de emissão',
      createDate: 'Data de criação',
    },
    asaasStatus: {
      SCHEDULED: 'Processando',
      SYNCHRONIZED: 'Enviada à prefeitura',
      AUTHORIZED: 'Autorizada',
      PROCESSING_CANCELLATION: 'Cancelando',
      CANCELED: 'Cancelada',
      CANCELLATION_DENIED: 'Cancelamento negado',
      ERROR: 'Erro na emissão',
    },
    status: {
      REFUSED: 'Recusada',
      APPROVED: 'Aprovada',
      AWAITING_APPROVAL: 'Aguardando aprovação',
    },
    commentOptions: {
      noValue: 'Valor não disponível',
      wrongValue: 'Valor errado',
      noDocument: 'Documento não informado',
      wrongDocument: 'Documento errado',
      wrongCNPJ: 'CNPJ errado',
      wrongDescription: 'Descrição errada',
      noInvoice: 'Nota fiscal já recebida',
      noServiceTaker: 'Tomador do serviço não informado',
      wrongServiceTaker: 'Tomador do serviço incorreto',
      other: 'Outro',
    },
    messages: {
      invoiceNotFound: 'Fatura não encontrada',
      noInvoicePayments: 'Não foi possível enviar a nota fiscal, pois não há pagamentos associados a ela',
      noPendingInvoices: 'Não há faturas pendentes para aprovar',
      hausefulInvoices: 'Notas fiscais enviadas pela Hauseful',
      hostInvoices: 'Notas fiscais enviadas por Hosts',
      valueMatches: 'O valor corresponde ao valor da fatura',
      valueNotMatches: 'O valor {amountValue} não corresponde ao valor da fatura {amountInvoiceValue}',
      documentMatches: 'O documento corresponde ao do destinatário da fatura',
      documentNotMatches: 'O documento não corresponde ao do destinatário da fatura',
      cnaeMatches: 'CNAE válido',
      cnaeNotMatches: 'CNAE inválido',
      reviewUnavailable: 'Revisão indisponível',
      reviewPassed: 'Revisão aprovada',
    },
    HAUSEFUL: 'Hauseful',
    CUSTOMER: 'Cliente',
    HOST: 'Host',
  },
}

export default brInvoices
